<template>
  <div
    v-if="show"
    class="fixed inset-0 z-50 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <!-- Background overlay -->
    <div
      class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
    >
      <div
        class="fixed inset-0 transition-opacity bg-charcoal-9000 bg-opacity-75"
        aria-hidden="true"
      />

      <!-- Modal panel -->
      <div
        class="inline-block align-bottom bg-charcoal-800 rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
      >
        <div class="sm:flex sm:items-start">
          <div
            class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10"
          >
            <!-- Clock icon -->
            <Clock :size="24" class="text-yellow-600" :stroke-width="2" />
          </div>
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 id="modal-title" class="text-lg leading-6 font-medium text-white">
              Session Expired
            </h3>
            <div class="mt-2">
              <p class="text-sm text-charcoal-400">
                Your session has expired. Please sign in again to continue.
              </p>
            </div>
          </div>
        </div>
        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
            @click="handleSignIn"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth.store'
import { Clock } from 'lucide-vue-next'

const router = useRouter()
const authStore = useAuthStore()
const show = ref(false)

function open() {
  show.value = true
}

function close() {
  show.value = false
}

async function handleSignIn() {
  close()
  // Clear auth state
  await authStore.logout({ returnTo: window.location.origin + '/login' })
  // Navigate to login
  router.push('/login')
}

defineExpose({
  open,
  close,
})
</script>
